module.exports = __webpack_public_path__ + "dist/img/review-unpass.73ef3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/review-unpass.png
// module id = HJmZ
// module chunks = 1